import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { observeElementSize, unobserveElementSize } from '../services/observeElementSize';
var ObserveSize = /*#__PURE__*/function (_React$Component) {
  function ObserveSize() {
    var _this;
    _classCallCheck(this, ObserveSize);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ObserveSize, [].concat(args));
    _defineProperty(_this, "sizeRef", function (el) {
      if (el) {
        observeElementSize(el, _this.props.observerFn);
        _this.element = el;
      }
    });
    return _this;
  }
  _inherits(ObserveSize, _React$Component);
  return _createClass(ObserveSize, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.element) {
        unobserveElementSize(this.element);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __jsx("div", {
        style: {
          width: '100%'
        },
        ref: this.sizeRef,
        "data-id": "components_ObserveSize_div"
      }, this.props.children);
    }
  }]);
}(React.Component);
export default ObserveSize;